var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgInvoices = function SvgInvoices(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C12 12.8954 12.8954 12 14 12H26C27.1046 12 28 12.8954 28 14C28 15.1046 27.1046 16 26 16H14C12.8954 16 12 15.1046 12 14Z",
    fill: "#8290A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21C12.8954 21 12 21.8954 12 23C12 24.1046 12.8954 25 14 25H26C27.1046 25 28 24.1046 28 23C28 21.8954 27.1046 21 26 21H14Z",
    fill: "#8290A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 32C12 30.8954 12.8954 30 14 30H26C27.1046 30 28 30.8954 28 32C28 33.1046 27.1046 34 26 34H14C12.8954 34 12 33.1046 12 32Z",
    fill: "#8290A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16C35.1046 16 36 15.1046 36 14C36 12.8954 35.1046 12 34 12H33.99C32.8854 12 31.99 12.8954 31.99 14C31.99 15.1046 32.8854 16 33.99 16H34Z",
    fill: "#8290A2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23C36 24.1046 35.1046 25 34 25H33.99C32.8854 25 31.99 24.1046 31.99 23C31.99 21.8954 32.8854 21 33.99 21H34C35.1046 21 36 21.8954 36 23Z",
    fill: "#8290A2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 34C35.1046 34 36 33.1046 36 32C36 30.8954 35.1046 30 34 30H33.99C32.8854 30 31.99 30.8954 31.99 32C31.99 33.1046 32.8854 34 33.99 34H34Z",
    fill: "#8290A2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7C4 4.23858 6.23858 2 9 2H39C41.7614 2 44 4.23858 44 7V41C44 43.7614 41.7614 46 39 46H9C6.23857 46 4 43.7614 4 41V7ZM9 6C8.44771 6 8 6.44772 8 7V41C8 41.5523 8.44771 42 9 42H39C39.5523 42 40 41.5523 40 41V7C40 6.44771 39.5523 6 39 6H9Z",
    fill: "#8290A2"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInvoices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/invoices.06b44806.svg";
export { ForwardRef as ReactComponent };